import Vue from 'vue';
import Vuex from 'vuex';

import * as mutations from './mutations';
import * as getters from './getters';

const state = {
	currentCategory: 'all',
	currentGame: {},
}

Vue.use(Vuex);

const store = new Vuex.Store({
	state,
	mutations,
	getters,
});

export default store;


// WEBPACK FOOTER //
// ./src/store/index.js